import * as React from 'react';
import {FC, useEffect} from 'react';
import ListComponent from './ListComponent';
import formStateUpdate from './formStateUpdate';
import {ElementLogic} from './types';
import {FormApi} from 'final-form';
import {merge, isObject} from 'lodash';

interface FormRootProps {
  form: FormApi<Record<string, any>>,
  initialValues: any,
  formDefinition: ElementLogic[],
}

const FormRoot: FC<FormRootProps> = ({initialValues, formDefinition, form}) => {
  useEffect(() => {
    if (isObject(initialValues)) {
      // keep original initial values for field array size
      const newValues = merge({}, form.getState().values, initialValues);
      formStateUpdate(form, newValues);
    }
  }, [initialValues])

  return <ListComponent parent="" data={formDefinition} />
}

export default FormRoot;
